import React, { Suspense } from "react";
import Container from "react-bootstrap/Container";
import { withRouter, useLocation } from "react-router-dom";
import routes from "../../../routes/routes";
import Topbar from "../../organisms/Topbar/Topbar";
import Navbar from "../../organisms/Navbar/Navbar";
import SmallNavigation from "../../organisms/SmallNavigation/SmallNavigation";
import Footer from "../../organisms/Footer/Footer";
import BottomBar from "../../organisms/BottomBar/BottomBar";
import RouterView from "../../organisms/RouterView/RouterView";
import CarouselRibbon from "../../organisms/CarouselRibbon/CarouselRibbon";
import Marquee from "../../molecules/Marquee/Marquee";
// import Popup from "../../organisms/Popup/Popup";

const includeSmallNavigation = [
  "parts",
  "details",
  "search",
  "features",
  "distributors",
  "info",
  "faq",
];

const MainLayout = ({ location }) => {
  const locations = useLocation();

  return (
    <>
      <Topbar />
      <Marquee />
      <Navbar />
      <Container>
        {locations.pathname !== "/" ? <CarouselRibbon /> : null}
        {/* <Popup /> */}
      </Container>
      {includeSmallNavigation.some((item) =>
        location.pathname.includes(item)
      ) && <SmallNavigation />}
      <Suspense
        fallback={
          <p
            style={{
              fontSize: "1.5rem",
              maxWidth: "1140px",
              margin: "0 auto",
            }}
          >
            Loading...
          </p>
        }
      >
        <RouterView routes={routes} />
      </Suspense>
      <Footer />
      <BottomBar />
    </>
  );
};

export default withRouter(MainLayout);
